import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config,ApiResponseModel,PagingResponseModel,Pagination } from '../shared';
import { DepositRequisitionEntityAttachmentContainerModel } from '../../../../../models/aggregates/deposit-requisition-hdr-entity-attachment';
import { Observable } from 'rxjs';
import { BasicApiResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class DepositRequisitionEntityAttachmentService extends BaseApiPublicLoginTemplateService<DepositRequisitionEntityAttachmentContainerModel,DepositRequisitionEntityAttachmentContainerModel,DepositRequisitionEntityAttachmentContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit/requisition/hdr-entity-attachments/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit/requisition/hdr-entity-attachments/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit/requisition/hdr-entity-attachments/' + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'deposit/requisition/hdr-entity-attachments/' + BaseApiTemplateService.PUBLIC_EP;
    this.httpClient = http;
  }

  addAttachments(requisitionEntityLinkGuid: string, files: File[], visa: ApiVisa): Observable<BasicApiResponseModel<DepositRequisitionEntityAttachmentContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const formData: FormData = new FormData();
    files.forEach(file => formData.append('file', file));

    return this.httpClient.post<BasicApiResponseModel<DepositRequisitionEntityAttachmentContainerModel>>(
      this.apiUrl + '/' + requisitionEntityLinkGuid,
      formData,
      this.getHttpHeader(visa)
    );
  }

  public getAttachmentFile(attachmentGuid: string, apiVisa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + '/file/' + attachmentGuid,
      this.getHttpHeaderBlob(apiVisa)
    );
  }

  public deleteAttachment(attachmentGuid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<any>>(
      this.apiUrl + '/' + attachmentGuid,
      this.getHttpHeader(visa)
    );
  }

  public getAttachmentByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}